import Vue from 'vue'
import axios from 'axios'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import DefaultLayout from './layouts/Default'
import BlankLayout from './layouts/Blank'
import BlankNoLogoLayout from './layouts/BlankNoLogo'
// import 'vuetify/dist/vuetify.min.css'
import $ from 'jquery'

import BFTNutrition from './plugins/bft-nutrition-plugin'

Vue.use(BFTNutrition, { store, router })

window.$ = window.jQuery = $
window.axios = axios

Vue.config.productionTip = false

Vue.http = Vue.prototype.$http = axios

Vue.component('default-layout', DefaultLayout)
Vue.component('blank-layout', BlankLayout)
Vue.component('blank-no-logo-layout', BlankNoLogoLayout)

var check_upgrade = new Event('check-for-upgrade');

const publicPages = ['/login', '/welcome', '/register', '/forgot'];
const loggedOutPages = ['/login', '/welcome', '/register', '/forgot'];

router.beforeEach((to, from, next) => {

  // redirect to login page if not logged in and trying to access a restricted page
  const authRequired = !publicPages.includes(to.path);
  const loggedOutPage = loggedOutPages.includes(to.path);
  const loggedIn = store.getters['auth/isLoggedIn'];

  store.commit('global/SET_MESSAGE', null)

  window.dispatchEvent(check_upgrade);

  store.dispatch('messages/setCurrentRoute', to.path)

  if (authRequired && !loggedIn) {
    return next('/welcome');
  }

  const hasChallenge = store.getters['auth/hasChallenge'];


  if(hasChallenge
      && (store.getters['challenge/agreeTerms'] === 0 || store.getters['challenge/agreeTerms'] === 3)
      && to.path.indexOf('tsandcs') < 0) {
    return next('/tsandcs')
  }


  if(!hasChallenge && to.path.indexOf('select-challenge') < 0 && loggedIn) {
    return next('/select-challenge')
  }

  if(hasChallenge
      && store.getters['challenge/agreeTerms'] < 3
      && store.getters['challenge/agreeTerms'] > 0
      && to.path.indexOf('tsandcs') >= 0) {
    return next('/');
  }

  if(hasChallenge && to.path.indexOf('select-challenge') >= 0) {
    return next('/');
  }

  if(loggedOutPage && loggedIn) {
    if(!hasChallenge) {
      return next('/select-challenge')
    } else {
      return next('/');
    }
  }

  next();
})

store.dispatch('auth/initialise').then(() => {

  new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
  }).$mount('#app')

})

// listen to the service worker promise in index.html to see if there has been a new update.
// condition: the service-worker.js needs to have some kind of change - e.g. increment CACHE_VERSION.
/*
window['isUpdateAvailable']
    .then(isAvailable => {

      if (isAvailable) {
        console.log("NEW UPDATE");
      }
    });
*/



window.addEventListener('offline', () => {
  store.commit('global/SET_OFFLINE', true)
});
window.addEventListener('online', () => {
  store.commit('global/SET_OFFLINE', false)
});

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {

  if (error.response && error.response.status === 401) {
    var path = router.currentRoute.path
    if(!loggedOutPages.includes(path)) {
      store.dispatch('auth/logout')
      router.push('/login')
    }

  }
  return Promise.reject(error)
})
